import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppStateSelector, pick } from "@nosto/preact"
import { useEffect } from "preact/hooks";
import { currency } from "../helpers"

export default function Products() {
    // const {
    //     products,
    //     loading
    // } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    const { loading, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "response", "pageType")
    )
    console.log(pageType)
   

    useEffect(()=>{
        if(pageType === "search"){
            const nativeQuantityElement = document.querySelector(".search-hero__title small");
            if(nativeQuantityElement){
                nativeQuantityElement.textContent = `${response?.products?.total}`;
            }
        }

    }, [response.products])

    useEffect(() => {
        if(!window.Nosto?.migrateToShopifyMarket) return;
        window.Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-serp .ns-markets',
            productHandleAttribute: 'data-handle',
            productUrlElement: '.ns-serp .product-card__link',
            priceElement: '.ns-serp .ns-price',
            listPriceElement: '.ns-serp .ns-list-price',
        })
    }, [ response?.products?.hits ])

    return (
        // ns-d-flex ns-flex-wrap 
        <div class="collection__grid collection-grid-container__products"
        data-cols="4" 
        // style={loading ? "opacity: 0.3;" : ""}
        >
            {response.products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
